var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { omit } from 'lodash';
import * as i0 from "@angular/core";
var QuestionnaireService = /** @class */ (function () {
    function QuestionnaireService() {
        this._questionnaire = [];
    }
    Object.defineProperty(QuestionnaireService.prototype, "questionnaire", {
        get: function () {
            return this._questionnaire;
        },
        set: function (payload) {
            this._questionnaire = payload;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Format questionnaire data in
     * the desired format
     * @param questionnaire raw data from forms
     */
    QuestionnaireService.prototype.setQuestionnairePayload = function (questionnaire) {
        var payload = questionnaire.map(function (question, index) {
            var _item = omit(question, 'questionType');
            _item.sortIndex = index + 1;
            if (question.answerOptions)
                _item.answerOptions = question.answerOptions
                    .map(function (option, j) {
                    return __assign({ sortIndex: j + 1 }, option);
                });
            return _item;
        });
        return payload;
    };
    QuestionnaireService.prototype.makeRequestPayload = function (questionnaire) {
        var payload = questionnaire.map(function (question, index) {
            var _item = omit(question, ['questionType', 'questionTypeConst', 'sortIndex']);
            // _item.sortIndex = index + 1;
            if (question.answerOptions)
                _item.answerOptions = question.answerOptions
                    .map(function (option, j) {
                    return option.availableAnswerText;
                });
            return _item;
        });
        return payload;
    };
    QuestionnaireService.ngInjectableDef = i0.defineInjectable({ factory: function QuestionnaireService_Factory() { return new QuestionnaireService(); }, token: QuestionnaireService, providedIn: "root" });
    return QuestionnaireService;
}());
export { QuestionnaireService };
